import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, Observable, tap, throwError } from 'rxjs';
import {
  CreateProviderParams,
  DeleteProviderByIdResponse,
  GetProviderByIdResponse, GetProviderRequestParams,
  GetProviderResponse, UpdateProviderRequestParams
} from '../../pages/providers/providers.interface';
import { environment } from '../../../environments/environment';
import { toQueryString } from '../../shared/helpers/helpers';

import { GetProviderListResponse } from '../../interfaces/providers.interface';


@Injectable({
  providedIn: 'root'
})
export class ProvidersService {
  private apiUrl = environment.api + '/providers';
  private tokenKey = environment.accessTokenName;

  constructor(private http: HttpClient) {}

  private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem(this.tokenKey)}`
    });
  }

  private handleResponse<T>(response: T & { code: number; message?: string }): T {
    if (response.code !== 0) {
      throw new Error(response.message);
    }
    return response;
  }

  private handleError(error: any): Observable<never> {
    console.error('API Error:', error);
    return throwError(() => new Error(error.error?.message || 'Error'));
  }

  getProviderService(requestParams: GetProviderRequestParams): Observable<GetProviderResponse> {
    const url = this.apiUrl + '?' + toQueryString(requestParams);
    return this.http.get<GetProviderResponse>(url, { headers: this.getHeaders() }).pipe(
      tap(response => this.handleResponse(response)), // ✅ Pakai arrow function
      catchError(error => this.handleError(error))   // ✅ Pakai arrow function
    );
  }

  getProviderById(id: string): Observable<GetProviderByIdResponse> {
    return this.http.get<GetProviderByIdResponse>(`${this.apiUrl}/${id}`, { headers: this.getHeaders() }).pipe(
      tap(response => this.handleResponse(response)),
      catchError(error => this.handleError(error))
    );
  }

  deleteProviderById(id: string): Observable<DeleteProviderByIdResponse> {
    return this.http.delete<DeleteProviderByIdResponse>(`${this.apiUrl}/${id}`, { headers: this.getHeaders() }).pipe(
      tap(response => this.handleResponse(response)),
      catchError(error => this.handleError(error))
    );
  }

  createProvider(providerData: CreateProviderParams): Observable<GetProviderByIdResponse> {
    return this.http.post<GetProviderByIdResponse>(this.apiUrl, providerData, { headers: this.getHeaders() }).pipe(
      tap(response => this.handleResponse(response)),
      catchError(error => this.handleError(error))
    );
  }

  updateProvider(id: string, providerData: UpdateProviderRequestParams): Observable<GetProviderByIdResponse> {
    return this.http.put<GetProviderByIdResponse>(`${this.apiUrl}/${id}`, providerData, { headers: this.getHeaders() }).pipe(
      tap(response => this.handleResponse(response)),
      catchError(error => this.handleError(error))
    );
  }


  getProviders(): Observable<GetProviderListResponse> {
    return this.http.get<GetProviderListResponse>(this.apiUrl, { headers: this.getHeaders() }).pipe(
      tap(response => this.handleResponse(response)),
      catchError(error => this.handleError(error))
    );
  }
}
